"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _dashboard = require("@/api/dashboard");
var _index = _interopRequireDefault(require("@/components/echarts/index"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    echartsFrom: _index.default
  },
  data: function data() {
    return {
      infoList: null,
      visitDate: 'last30',
      series: [],
      xAxis: [],
      info: {},
      legendData: [],
      yAxisData: [],
      statisData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId != null) {
      (0, _dashboard.offsetOrderListIndex)({
        offlineSupplierId: JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId
      }).then(function (res) {
        _this.statisData = res;
      });
    }
    this.yAxisData = [{
      type: 'value',
      name: '金额',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9'
        }
      }
    }, {
      type: 'value',
      name: '数量',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9'
        }
      }
      // axisLabel: {
      //     formatter: '{value} °C'
      // }
    }];
  },
  methods: {
    checkPermi: _permission.checkPermi,
    radioChange: function radioChange(val) {
      switch (val) {
        case 'week':
          this.handleChangeWeek();
          break;
        case 'month':
          this.handleChangeMonth();
          break;
        case 'year':
          this.handleChangeYear();
          break;
        default:
          this.handleChangeVisitType();
          break;
      }
    },
    // 时间改变
    handleChangeVisitType: function handleChangeVisitType() {
      var _this2 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.offsetOrderList)({
        supplierId: JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var pices, qualitys, key, _key;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this2.info = res;
                pices = [];
                qualitys = [];
                for (key in res.price) {
                  pices.push(Number(res.price[key]));
                  _this2.xAxis.push(key);
                }
                for (_key in res.quality) {
                  qualitys.push(Number(res.quality[_key]));
                }
                _this2.legendData = ['订单金额', '订单数'];
                _this2.series = [{
                  name: '订单金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: pices
                }, {
                  name: '订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleChangeWeek: function handleChangeWeek() {
      var _this3 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.offsetOrderListWeek)({
        supplierId: JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          var prePrice, price, qualitys, preQuality, key, _key2, _key3, _key4;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this3.info = res;
                _this3.legendData = ['上周金额', '本周金额', '上周订单数', '本周订单数'];
                prePrice = [];
                price = [];
                qualitys = [];
                preQuality = [];
                for (key in res.prePrice) {
                  prePrice.push(Number(res.prePrice[key]));
                  _this3.xAxis.push(key);
                }
                for (_key2 in res.price) {
                  price.push(Number(res.price[_key2]));
                }
                for (_key3 in res.preQuality) {
                  preQuality.push(Number(res.preQuality[_key3]));
                }
                for (_key4 in res.quality) {
                  qualitys.push(Number(res.quality[_key4]));
                }
                _this3.series = [{
                  name: '上周金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: prePrice
                }, {
                  name: '本周金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  data: price
                }, {
                  name: '上周订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#E6A23C'
                    }
                  },
                  yAxisIndex: 1,
                  data: preQuality
                }, {
                  name: '本周订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#768A9C'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleChangeMonth: function handleChangeMonth() {
      var _this4 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.offsetOrderListMonth)({
        supplierId: JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          var prePrice, price, qualitys, preQuality, key, _key5, _key6, _key7;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this4.info = res;
                _this4.legendData = ['上月金额', '本月金额', '上月订单数', '本月订单数'];
                prePrice = [];
                price = [];
                qualitys = [];
                preQuality = [];
                for (key in res.prePrice) {
                  prePrice.push(Number(res.prePrice[key]));
                  _this4.xAxis.push(key);
                }
                for (_key5 in res.price) {
                  price.push(Number(res.price[_key5]));
                }
                for (_key6 in res.preQuality) {
                  preQuality.push(Number(res.preQuality[_key6]));
                }
                for (_key7 in res.quality) {
                  qualitys.push(Number(res.quality[_key7]));
                }
                _this4.series = [{
                  name: '上月金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: prePrice
                }, {
                  name: '本月金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  data: price
                }, {
                  name: '上月订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#E6A23C'
                    }
                  },
                  yAxisIndex: 1,
                  data: preQuality
                }, {
                  name: '本月订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#768A9C'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    handleChangeYear: function handleChangeYear() {
      var _this5 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.offsetOrderListYear)({
        supplierId: JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId
      }).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          var prePrice, price, qualitys, preQuality, key, _key8, _key9, _key0;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this5.info = res;
                _this5.legendData = ['去年金额', '今年金额', '去年订单数', '今年订单数'];
                prePrice = [];
                price = [];
                qualitys = [];
                preQuality = [];
                for (key in res.prePrice) {
                  prePrice.push(Number(res.prePrice[key]));
                  _this5.xAxis.push(key);
                }
                for (_key8 in res.price) {
                  price.push(Number(res.price[_key8]));
                }
                for (_key9 in res.preQuality) {
                  preQuality.push(Number(res.preQuality[_key9]));
                }
                for (_key0 in res.quality) {
                  qualitys.push(Number(res.quality[_key0]));
                }
                _this5.series = [
                ////let col = ["#B37FEB", "#FFAB2B", "#1890FF", "#00C050"];
                {
                  name: '去年金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: prePrice
                }, {
                  name: '今年金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  data: price
                }, {
                  name: '去年订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#E6A23C'
                    }
                  },
                  yAxisIndex: 1,
                  data: preQuality
                }, {
                  name: '今年订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#768A9C'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 监听页面宽度变化，刷新表格
    handleResize: function handleResize() {
      if (this.infoList) this.$refs.visitChart.handleResize();
    }
  },
  created: function created() {
    this.handleChangeVisitType();
  }
};